/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-12 11:49:59
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-07-19 16:57:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/TopConfigs/ButtonText/index.tsx
 */
/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 11:07:36
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-07 14:54:39
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/TopConfigs/index.tsx
 */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Input, Select } from '@/src/components/Antd';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import {
  buttonTextValidation,
  errKey,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/validation';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { EPreviewSize, WebSiteSubType } from '@/src/types/common/SalesChannel';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import {
  EnumCollapseId,
  getButtonText,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getSubmitStamp,
  onButtonTextChange,
  onButtonThemeChange,
  onCollapseOpen,
  onErrorChange,
  resetButtonText,
  resetStaticConfig,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/slice';
import { store } from 'src/store';
import styles from './style.module.less';
import CountWords from '@/src/components/CountWords/CountWords';

function TopConfig(props) {
  const {
    isPrimary,
    data: buttonText,
    specificError,
    currentStyle,
    currentSize,
    themes = [],
  } = props;
  const textErr = specificError[errKey.textErr];
  const dispatch = useDispatch();

  const handleButtonTextChange = (value: string) => {
    dispatch(onButtonTextChange(value));
  };

  const handleButtonThemeChange = (v) => {
    dispatch(onButtonThemeChange(v));
  };

  useEffect(() => {
    return () => {
      dispatch(resetStaticConfig());
    };
  }, []);

  // const _BtnText = (
  //   <ItemWrapper
  //     title='Button Text'
  //     rightPart={
  //       <CountWords count={(buttonText.text || '').length} allCount={40} />
  //     }>
  //     <Input
  //       error={(textErr || []).length > 0}
  //       help={(textErr || []).join(' ')}
  //       size={'large'}
  //       className={styles.input}
  //       fullyControlledFilter={(v) => v}
  //       placeholder={'please input button text'}
  //       value={buttonText.text}
  //       onChange={handleButtonTextChange}
  //     />
  //   </ItemWrapper>
  // );

  switch (currentStyle) {
    case WebSiteSubType.NativeMobile: {
      return (
        <Section>
          <ItemWrapper
            title='Button Text'
            rightPart={
              <CountWords
                count={(buttonText.text || '').length}
                allCount={40}
              />
            }>
            <Input
              error={(textErr || []).length > 0}
              help={(textErr || []).join(' ')}
              size={'large'}
              className={styles.input}
              fullyControlledFilter={(v) => v}
              placeholder={'please input button text'}
              value={buttonText.text}
              onChange={handleButtonTextChange}
            />
          </ItemWrapper>
        </Section>
      );
    }
    case WebSiteSubType.ResponsivePage: {
      switch (currentSize) {
        case EPreviewSize.WIDE: {
          return (
            <React.Fragment>
              <Section>
                {isPrimary && (
                  <ItemWrapper title={'Button Theme'}>
                    <Select
                      size={'large'}
                      options={themes.map((v) => ({
                        label: v.name,
                        value: v.uuid,
                      }))}
                      value={buttonText?.buttonThemeUuid}
                      onChange={handleButtonThemeChange}
                    />
                  </ItemWrapper>
                )}
                <ItemWrapper
                  title='Button Text'
                  rightPart={
                    <CountWords
                      count={(buttonText.text || '').length}
                      allCount={40}
                    />
                  }>
                  <Input
                    error={(textErr || []).length > 0}
                    help={(textErr || []).join(' ')}
                    size={'large'}
                    className={styles.input}
                    fullyControlledFilter={(v) => v}
                    placeholder={'please input button text'}
                    value={buttonText.text}
                    onChange={handleButtonTextChange}
                  />
                </ItemWrapper>
              </Section>
            </React.Fragment>
          );
        }
        case EPreviewSize.TABLET: {
          return (
            <React.Fragment>
              <Section>
                <ItemWrapper title={'Button Theme'}>
                  <Select
                    size={'large'}
                    options={themes.map((v) => ({
                      label: v.name,
                      value: v.uuid,
                    }))}
                    value={buttonText?.buttonThemeUuid}
                    onChange={handleButtonThemeChange}
                  />
                </ItemWrapper>
              </Section>
            </React.Fragment>
          );
        }
        case EPreviewSize.MOBILE: {
          return (
            <React.Fragment>
              <Section>
                <ItemWrapper title={'Button Theme'}>
                  <Select
                    size={'large'}
                    options={themes.map((v) => ({
                      label: v.name,
                      value: v.uuid,
                    }))}
                    value={buttonText?.buttonThemeUuid}
                    onChange={handleButtonThemeChange}
                  />
                </ItemWrapper>
              </Section>
            </React.Fragment>
          );
        }
        default: {
          return (
            <React.Fragment>
              <Section>
                <ItemWrapper title={'Button Theme'}>
                  <Select
                    size={'large'}
                    options={themes.map((v) => ({
                      label: v.name,
                      value: v.uuid,
                    }))}
                    value={buttonText?.buttonThemeUuid}
                    onChange={handleButtonThemeChange}
                  />
                </ItemWrapper>
                <ItemWrapper
                  title='Button Text'
                  rightPart={
                    <CountWords
                      count={(buttonText.text || '').length}
                      allCount={40}
                    />
                  }>
                  <Input
                    error={(textErr || []).length > 0}
                    help={(textErr || []).join(' ')}
                    size={'large'}
                    className={styles.input}
                    fullyControlledFilter={(v) => v}
                    placeholder={'please input button text'}
                    value={buttonText.text}
                    onChange={handleButtonTextChange}
                  />
                </ItemWrapper>
              </Section>
            </React.Fragment>
          );
        }
      }
      break;
    }
    default: {
      return (
        <Section>
          <ItemWrapper
            title='Button Text'
            rightPart={
              <CountWords
                count={(buttonText.text || '').length}
                allCount={40}
              />
            }>
            <Input
              error={(textErr || []).length > 0}
              help={(textErr || []).join(' ')}
              size={'large'}
              className={styles.input}
              fullyControlledFilter={(v) => v}
              placeholder={'please input button text'}
              value={buttonText.text}
              onChange={handleButtonTextChange}
            />
          </ItemWrapper>
        </Section>
      );
    }
  }
}

export default ErrorProcessingHOC(TopConfig, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.buttonText,
  getContent: getButtonText,
  title: 'Button Text',
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return buttonTextValidation(x, !isPrimary);
  },
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(resetButtonText());
        },
        key: 'Reset',
        body: 'Reset',
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
